import React from 'react';
import LucideIcon from '../LucideIcon';

interface StreakChipProps {
  days: number;
}

// Foundation.dc.html's streak-flame chip -- flat ember, no gradient.
const StreakChip: React.FC<StreakChipProps> = ({ days }) => {
  const active = days > 0;
  return (
    <div
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        padding: '7px 14px', borderRadius: 999,
        background: active ? 'var(--ember-soft)' : 'var(--surface-sunken)',
        border: `1px solid ${active ? 'var(--ember)' : 'var(--border)'}`,
      }}
    >
      <span style={{ color: active ? 'var(--ember-strong)' : 'var(--text-tertiary)' }}>
        <LucideIcon name="streak" size={15} />
      </span>
      <span className="ws-display" style={{ fontSize: 14, fontWeight: 700, color: active ? 'var(--text-primary)' : 'var(--text-tertiary)' }}>
        {days}
      </span>
      <span style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-tertiary)' }}>
        day streak
      </span>
    </div>
  );
};

export default StreakChip;
